import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { ParallaxBanner } from 'react-scroll-parallax';

import { media } from '../../styles/media';

const Wrapper = styled(ParallaxBanner)`
  overflow: initial !important;

  .parallax-banner-layer-0,
  .parallax-banner-layer-1 {
    background-size: 200% !important;
    background-repeat: no-repeat !important;
    pointer-events: none;
  }

  .parallax-banner-layer-0 {
    background-position: center 20% !important;
  }

  .parallax-banner-layer-1 {
    background-position: right center !important;
    right: -39% !important;
    opacity: 0;
  }

  ${media.tablet`
    .parallax-banner-layer-0,
    .parallax-banner-layer-1 {
      background-size: 50% !important;
      opacity: 1;
      pointer-events: none;
    }
    .parallax-banner-layer-0 {
      background-position: -30% 20% !important;
    }

    .parallax-banner-layer-1 {
      background-position: right bottom !important;
    }
  `};
`;

class Watermark extends React.PureComponent {
  render() {
    const { children } = this.props;
    return (
      <Wrapper
        className={'ghd-parallax'}
        layers={[
          {
            image: '/static/images/watermark.svg',
            amount: 0.1,
            slowerScrollRate: false
          },
          {
            image: '/static/images/watermark.svg',
            amount: 0.1,
            slowerScrollRate: false
          }
        ]}
        style={{
          height: 'auto'
        }}
      >
        {children}
      </Wrapper>
    );
  }
}

Watermark.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export default Watermark;
